// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appPurchaseOrders/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appPurchaseOrders/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))

  const consolidated_response = await axios.get('/PurchaseOrders/ConsolidatedList', { params: { ...params, ServiceInvoice: false } })

  dispatch(setLoading({ getData: false }))

  return {
    params,
    data: {data: {list: [], totalRecords: 0}},
    consolidated: consolidated_response.data
  }
})

export const getTypeData = createAsyncThunk('appPurchaseOrders/getTypeData', async (params, { dispatch }) => {
  dispatch(setLoading({ getTypeData: true }))
  const response = await axios.get('/JVTypes/List', { params })
  dispatch(setLoading({ getTypeData: false }))
  return {
    params,
    data: response.data
  }
})


export const appPurchaseOrdersSlice = createSlice({
  name: 'appPurchaseOrders',
  initialState: {
    purchaseOrders: {},
    data: [],
    totalRecords: 1,
    typeData: [],
    totalTypeRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        // console.log(state, action)
        state.data = action.payload.data.data.list
        state.consolidated = action.payload.consolidated.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.consolidatedTotalRecords = action.payload.consolidated.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appPurchaseOrdersSlice.reducer
